import { useCallback, useState } from "react";
import { Contact } from "@/app/providers/services";

import SplitPane from "@imminently/decisively-ui/SplitPane";

import type { ContactIdentity } from "./ContactIdentityStatus";
import { ContactPanel } from "./ContactPanel";
import { ContactTable } from "./ContactTable";
import { ContactMappingProvider } from "./MappingContext";

export const Contacts = () => {
  const [contact, setContact] = useState<Contact | null>(null);
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  // Login statuses checked by opening contacts, shown in the table until the list is refetched.
  const [checkedIdentities, setCheckedIdentities] = useState<Record<string, ContactIdentity>>({});
  const onIdentityChecked = useCallback((contactId: string, identity: ContactIdentity) => {
    setCheckedIdentities((current) => {
      const existing = current[contactId];
      if (existing?.identityId === identity.identityId && existing?.identitySource === identity.identitySource) return current;
      return { ...current, [contactId]: identity };
    });
  }, []);

  const onContactClick = (contact: Contact) => {
    console.log("Contact clicked:", contact);
    setContact(contact);
  };

  const onClose = () => {
    setContact(null);
  };

  const onDeleted = (deletedContact: Contact) => {
    setContact((current) => (current?.id === deletedContact.id ? null : current));
  };

  return (
    <ContactMappingProvider>
      <div className="flex h-full w-full overflow-hidden">
        <SplitPane
          direction="horizontal"
          gutterSize={6}
          className="border-t"
        >
          <SplitPane.Pane minSize={300}>
            <ContactTable
              onClick={onContactClick}
              onDeleted={onDeleted}
              searchInput={searchInput}
              searchTerm={searchTerm}
              onSearchInputChange={setSearchInput}
              onSearchTermChange={setSearchTerm}
              checkedIdentities={checkedIdentities}
              selectedContactId={contact?.id ?? null}
            />
          </SplitPane.Pane>
          <SplitPane.Pane
            minSize={400}
            preferredSize="50%"
            visible={Boolean(contact)}
          >
            {contact ? <ContactPanel contact={contact} onClose={onClose} onIdentityChecked={onIdentityChecked} /> : null}
          </SplitPane.Pane>
        </SplitPane>
      </div>
    </ContactMappingProvider>
  );
};
